const isWon = (result, side = 'home') => {
  const goals = result.split(':');
  return side === 'home' ? goals[0] >= goals[1] : goals[0] <= goals[1];
};

export default isWon;
